<template>
  <main class="vh100">
    <router-view
      v-if="hasLogin || $route.path === '/mine/help'"
      :learn-info="learnInfo"
      :course-list="courseList"
      :is-privilege="isPrivilege"
      :coupon-list="couponList"
      :send-courses="sendCourses" />

    <div class="notLogin" v-if="!hasLogin && $route.path !== '/mine/help'">
      <img src="../assets/images/mine-not-login.png"/>
      <p>您还没有登录呦</p>
      <app-button class="loginBtn" width="230"><span @click="goLogin">立即登录</span></app-button>
    </div>
  </main>
</template>

<script>
import api from '@edu-fe/api'
import keys from 'lodash.keys'
import module from '../modules/mine'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
// import login from '@edu-fe/login'
import Button from '../components/UI/Button'
import login from '@/utils/login'
import Cookie from 'js-cookie'

export default {
  name: 'MineRouter',

  components: {
    appButton: Button
  },

  data () {
    return {
      hasLogin: false
    }
  },

  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters)),
    ...mapState(['isPrivilege']),
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    if (Cookie.get('openid') && Cookie.get('openid') !== '') {
      this.init()
      this.hasLogin = true
      return
    }
    // 校验登录状态
    if (this.$route.path === '/mine/help') {
      return
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    ...mapActions(['getPrivilege']),
    goLogin () {
      window.sessionStorage.setItem('loginTime', (new Date()).getTime())
      login.login()
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";

main {
  width: 100%;
  /*min-height: 100vh;*/
  background-color: #f3f4f6;
  .notLogin {
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #F3F4F6;
    text-align: center;

    img {
      height: rem(200);
      width: rem(286);
      margin-top: rem(303);
      margin-bottom: rem(30);
    }

    p {
      color: #999;
      font-size: rem(26);
      line-height: rem(37);
      text-align: center;
    }

    .loginBtn {
      margin: rem(46) auto;

      span {
        display: inline-block;
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>

